// extracted by mini-css-extract-plugin
export default {"mainContainer":"FormContent_mainContainer__kobzl","formContainer":"FormContent_formContainer__t3TRa","submitContainer":"FormContent_submitContainer__VrU0j"};